/**
* @Description: 单元整体回忆
* @author wangshu
* @date 2020/4/2
*/
<template>
    <div class="all-wrap">
        <div class="left-title">
            <div>
                <img src="../../../../assets/img/grammarTest/book.png" alt="">
                <p><b>{{dataSource.edition_name}}{{dataSource.curriculum_name}}·{{dataSource.unit_name}}</b></p>
            </div>
        </div>
        <div class="recall-box">
            <!-- <transition name="el-fade-in-linear" mode="out-in"> -->
                <!--强制复习的提示语-->
                <div class="hint-text" v-if="isHint" key="save">
                    <template v-if="grammarList.length!=0">
                        <div>最后进行“单元整体回忆”，再次巩固记忆</div>
                        <div></div>
                        <div style="margin-top: 30px;">
                            <el-button type="success" @click="startOverallMemory">开始回忆</el-button>
                        </div>
                    </template>
                    <template v-else>
                        <div>暂无回忆的单词</div>
                        <div></div>
                        <div style="margin-top: 30px;">
                            <el-button type="success" @click="closePop">退出</el-button>
                        </div>
                    </template>
                </div>
                <!--练习框-->
                <div class="word-list td-f1 td-fc" v-if="isDemo&&grammarList.length!=0" key="1">
                    <div class="word-box">
                        <div class="word-item list-item"
                                v-for="(item,index) in grammarList" :key="index"
                                @click="showTranslation(index)" :class="{show: item.show}">
                            <div>
                                <div class="item-1 animated fadeInDown" v-if="!item.clicked">
                                    {{item.name}}
                                </div>
                                <div class="item-2 animated fadeInUp" v-if="item.clicked">
                                    {{item.meaning?item.meaning:'暂无词义'}}
                                </div>
                                <audio :id="`eventAudio+${index}`" :src="item.voice"></audio>
                                <img class="voice" @click.stop="playAudio(`eventAudio+${index}`)"
                                        src="@/assets/img/grammarTest/volume3_active.png">
                            </div>
                        </div>
                    </div>
                    <div class="exit" @click="toExitHalfway">exit</div>
                </div>
            <!-- </transition> -->
            <!-- <transition name="el-fade-in-linear" mode="out-in"> -->
                <div class="result-box" key="2" v-if="showResult">
                    <div class="left-box">
                        <div class="test-info">
                            <img src="../../../../assets/img/grammarTest/dot.png" alt="">
                            <span>记忆夹生词（个）：</span><span>{{resultData.jiyi_strange}}</span>
                        </div>
                        <div class="test-info" v-if="unitData.is_open != 1">
                            <img src="../../../../assets/img/grammarTest/dot.png" alt="">
                            <span>拼写夹生词（个）：</span><span>{{resultData.pinxie_strange}}</span>
                        </div>
                        <div class="test-info">
                            <img src="../../../../assets/img/grammarTest/dot.png" alt="">
                            <span>连续识别错误（个）：</span><span>{{resultData.study_error}}</span>
                        </div>
                        <div class="test-info" v-if="unitData.is_open != 1">
                            <img src="../../../../assets/img/grammarTest/dot.png" alt="">
                            <span>连续拼写错误（个）：</span><span>{{resultData.spell_error}}</span>
                        </div>
                        <div class="test-info">
                            <img src="../../../../assets/img/grammarTest/dot.png" alt="">
                            <span>继续学习可获得更多武力值</span>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="top-img-icon">
                            <img src="../../../../assets/img/grammarTest/test_paper.png" alt="">
                            <div>复习小结</div>
                        </div>
                        <div class="img-icon">
                            <img src="../../../../assets/img/grammarTest/treasure_box.png" @click="startOverallMemory" />
                            <div>本次复习将收获{{resultData.point}}能量石</div>
                        </div>
                        <div class="right-btn">
                            <el-button type="primary" @click="startUnitTest">单元测试</el-button>
                            <el-button type="danger" @click="closePop()">保存退出</el-button>
                        </div>
                    </div>
                </div>
            <!-- </transition> -->
        </div>
    </div>
</template>
<script>
    import {mapState, mapGetters, mapMutations} from 'vuex';
    import Lockr from 'lockr'
    import {unitMemory, quitUnitMemory} from "@/api/tiyan";

    export default {
        name: "yfOverallMemory",
        props: {
            showPop: {},
        },
        data() {
            return {
                isHint: true,//是否显示强制复习提示语
                isDemo: false,
                showResult: false,
                dataSource: '',//凭证
                grammarList: [],//单词列表
                resultData: {},//结果
            };
        },
        computed: {
            ...mapGetters(['wordStudyStage', 'unitData']),
        },
        created() {
            this.$store.commit("UPDATE_STUDY_STEP", 4)
            this.getWord()
            console.log('unitData', this.unitData)
        },
        methods: {
            ...mapMutations(['CHANGE_STUDY_TYPE']),
            //触发发音
            playAudio(e) {
                let buttonAudio = document.getElementById(e);
                buttonAudio.play()
            },
            //获取单词列表
            async getWord() {
                this.dataSource = this.wordStudyStage.dataSource
                let params = {
                    token: Lockr.get('token'),
                    unit_id: this.dataSource.unit_id,
                }
                let result = await unitMemory(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.curriculum = result.data.curriculum
                    let list = result.data
                    list.length && list.map((item) => {
                        item.clicked = false
                        item.show = false
                    })
                    this.grammarList = list
                    this.showTimeout()
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    })
                }
            },
            // 逐个显示
            showTimeout() {
                let n = 0
                let t = setInterval(() => {
                    if (this.grammarList[n]) {
                        this.grammarList[n].show = true
                        n++
                    }
                    if (n > this.grammarList.length) {
                        window.clearInterval(t)
                    }
                }, 1000)

            },
            //查看释义
            showTranslation(index) {
                this.grammarList[index].clicked = !this.grammarList[index].clicked
            },
            // 中途退出
            toExitHalfway () {
                this.$store.commit("UPDATE_UNIT_COMPLET", true)
                this.$emit('quit', 'exitHalfway')
            },
            // 开始回忆
            startOverallMemory() {
                this.isHint = false;
                this.showResult = false
                this.isDemo = true
            },
            //关闭学习窗口
            closePop() {
                this.$emit('quit')
            },
            //查看复习小结
            goResult() {
                this.isHint = false;
                this.isDemo = false
                this.showResult = true
                let params = {
                    token: Lockr.get('token'),
                    unit_id: this.dataSource.unit_id,
                }
                quitUnitMemory(params).then(res => {
                    if (res.code == 1) {
                        this.resultData = res.data
                    }else {
                        this.$alert(result.msg, '温馨提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                })
            },
            //开始单元测试
            startUnitTest() {
                let id = this.$route.query.id
                this.$router.push(`unitTest?type=4&id=${id}`)
            },
        }
    }
</script>

<style scoped lang='less'>
.all-wrap {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;

    .left-title {
        padding: 10px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        > div:nth-of-type(1) {
            display: flex;
            align-items: center;

            p {
                font-size: 18px;
            }

            img {
                width: 26px;
                height: 26px;
                margin-right: 10px;
            }
        }

        .countDown {
            background: url('../../../../assets/img/grammarTest/time_bg.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 50px;
            height: 50px;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .recall-box {
        transition: all .5s;
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .hint-text {
            flex: 1;
            position: relative;
            text-align: center;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            > div:nth-of-type(2) {
                color: #FF626F;
                margin: 5px 0;
            }
        }

        .exit {
            position: absolute;
            bottom: 30px;
            right: 40px;
            width: 71px;
            height: 71px;
            background: #3A85D8;
            opacity: 0.65;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            color: #fff;
            border-radius: 50%;
            cursor: pointer;
            transition: all .5s;
        }

        .exit:hover {
            opacity: 1;
        }
    }

    .word-box {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        overflow-y: scroll;
        height: 400px;
        .word-item {
            width: 31.333333%;
            height: 100px;
            margin: 10px 1%;
            background: linear-gradient(270deg, rgba(55, 205, 215, 1) 0%, rgba(0, 181, 194, 1) 100%);
            border-radius: 4px;
            position: relative;
            font-size: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            cursor: pointer;
            padding: 5px 0;
            opacity: 0;
            transition: 1s;

            .item-1 {
                height: 100%;
                font-size: 24px;
                padding: 10px;
                text-align: center;
                font-weight: 600;
            }

            .voice {
                width: 25px;
                height: 25px;
                position: absolute;
                bottom: 8px;
                right: 5px;
            }

            .item-2 {
                font-size: 20px;
                font-weight: 600;
                padding: 0 10px;
            }
        }

        .word-item.show {
            opacity: 1;
        }
    }

    .result-box {
        display: flex;
        width: 100%;

        .left-box, .right-box {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 18px;
            font-weight: 600;

            .test-info {
                width: 330px;
                display: flex;
                align-items: center;
                margin: 10px 0;
                padding: 8px 15px;
                border-radius: 3px;
                box-shadow: 0 0.08333rem 1rem 0.25rem rgba(0, 0, 0, 0.08);

                img {
                    width: 30px;
                    margin-right: 10px;
                }

                .bad-test {
                    color: #f56c6c;
                }
            }
            .top-img-icon {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;

                img {
                    width: 30px;
                    height: 30px;
                }
            }
        }

        .right-box {
            .right-btn {
                margin-top: 30px;
            }

            .img-icon {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                img {
                    margin: 15px 0;
                }
            }
        }
    }

    .list-item {
        display: inline-block;
        margin-right: 10px;
    }

    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }

    .list-enter, .list-leave-to
        /* .list-leave-active for below version 2.1.8 */ {
        opacity: 0;
        transform: translateY(30px);
    }
}
</style>